/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

// @ts-nocheck
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useMemo, useState, useRef } from 'react';
import { Field, Form, Formik } from 'formik';
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import { Col, Row } from 'components/Grid';
import Icon from 'components/Icon';
import Colors from 'constants/Colors';
//import InputField from 'components/Form/InputField';
import { GridColumnTitle, InputField } from "components/Form";
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { useHistory, useLocation } from 'react-router-dom';
import FormContainer from 'components/FormContainer';
import Loader from 'components/Loader';
import {
  Text, Content, ListContent, Container, FolderSelect, RowSearch, RowFilter, DialogSelect, FieldGrid,
  FilterColumn, CheckBoxColumn,
} from './styles';
import Checkbox from 'components/Form/CheckBox';
import { Label } from 'components/Form';
import DragZoneUpload from 'components/DragZoneUpload'
import ListDetail from './listDetail';
import ListHeader from './listHeader';
import MessageExchangeEmail from 'components/MessageExchangeEmail';

import _ from 'lodash';
import RateUs from 'components/RateUs';
import { InputContainer } from 'components/Form/SearchField';
import StepNavigation from 'components/StepNavigation/index';
import CacheManager from 'utils/src/cache-manager';
import DialogComponent from 'components/Dialog';
import {useGetDealDocumentsV2, useGetDealDocuments} from 'services/DocumentsService';
import {useListMarkets, useHeaderNbi} from 'services/QuoteService';

export default function DocumentManagement(props) {

  const columns = [

    {
      title: "Name",
      value: "documentName",
      col: 3,
      style: ''
    },
    {
      title: "Version",
      value: "version",
      col: 2,
      style: ''
    },
    {
      title: "Document Type",
      value: "documentType",
      col: 2,
      style: ''
    },
    {
      title: "Uploaded By",
      value: "uploadedBy",
      col: 2,
      style: ''
    },
    {
      title: "Date",
      value: "uploadedDate",
      col: 2,
      style: ''
    },

    {
      title: "Action",
      value: "action",
      col: 1,
      style: 'pr-0'
    },

  ];

  const initialValues = {
    search: ""
  };

  const formik = useRef(null);
  const cache = new CacheManager();
  const authContext = useContext(GlobalAuthContext);
  const isClient = useMemo(() => authContext.enumProfile === 1, []);
  const [summary, setSummary] = useState({});
  const [shouldRenderOperationFilter, setShouldRenderOperationFilter] = useState(false);
  const [operationsList, setOperationsList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [insurerInfo, setInsurerInfo] = useState([]);
  const [insurerSelected, setInsurerSelected] = useState(null);
  const [filter, setFilter] = useState(
    {
      key: null,
      direction: null,
    }
  );
  const [data, setData] = useState([/* { nmParty: '', nmInterest: '', documentType: '', uploadBy: '', date: '', action: '' } */]);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);
  const [documents, setDocuments] = useState([]);
  const location = useLocation();
  const [dealDocuments, setDealDocuments] = useState(0);
  const [signedDocuments, setSignedDocuments] = useState(0);
  const [internalDocuments, setInternalDocuments] = useState(0);
  const [claimsDocuments, setClaimsDocuments] = useState(0);
  const [supportDocuments, setSupportDocuments] = useState(0);
  const [communicationDocuments, setCommunicationDocuments] = useState(0);
  const [nbiDocuments, setNbiDocuments] = useState(0);
  const [paymentDocuments, setPaymentDocuments] = useState(0);
  const [renderScreen, setRenderScreen] = useState("");
  const [showAttachments, setShowAttachments] = useState(false);
  const [attachemnts, setAttachments] = useState([]);
  const [showRateUs, setShowRateUs] = useState(false);
  const [showChatModal, setShowChatModal] = useState(false);
  const [selectedDocs, setSelectedDocs] = useState([]);
  const [selectedAllDocsCheckBox, setSelectedAllDocsCheckBox] = useState(false);
  const [nameArrayChecked, setNameArrayChecked] = useState([]);
  const [tooltips, setTooltips] = useState([]);
  const [documentsExpired, setDocumentsExpired] = useState([]);

  const {
    data: useGetDealDocumentsData,
    loading: useGetDealDocumentsLoading,
    error: useGetDealDocumentsError,
    status: useGetDealDocumentsStatus,
    request: useGetDealDocumentsRequest,
  } = useGetDealDocuments(props.match.params.idOperation);

  const {
    data: useGetDealDocumentsV2Data,
    loading: useGetDealDocumentsV2Loading,
    error: useGetDealDocumentsV2Error,
    status: useGetDealDocumentsV2Status,
    request: useGetDealDocumentsV2Request,
  } = useGetDealDocumentsV2(props.match.params.idOperation);

  const {
    data: useListMarketsData,
    loading: useListMarketsLoading,
    error: useListMarketsError,
    status: useListMarketsStatus,
    request: useListMarketsRequest,
  } = useListMarkets(props.match.params.idOperation);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  useEffect(() => {
    if (useGetDealDocumentsV2Loading || useListMarketsLoading || useHeaderNbiLoading || useGetDealDocumentsLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [ useGetDealDocumentsV2Loading, useListMarketsLoading, useHeaderNbiLoading, useGetDealDocumentsLoading ]);

  const [sortBy, setSortBy] = useState(
    {
      key: null,
      direction: null,
    }
  );

  const [dialog, setDialog] = useState({
    visible: false,
    title: '',
    icon: 'exclamation',
    args: null
  });


  useEffect(() => {
    if (selectedAllDocsCheckBox) {
      if (documents?.dealDocuments?.length) {
        setSelectedDocs(
          [
            ...documents.dealDocuments,
            ...documents.signedDocuments,
            ...documents.internalDocuments,
            ...documents.claimsDocuments,
            ...documents.supportDocuments,
            ...documents.communicationDocuments,
            ...documents.paymentDocuments,
            ...documents.nbiDocuments
          ])
      }
    } else {
      setSelectedDocs([]);
    }
  }, [selectedAllDocsCheckBox])

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);
    handleSummary();
    handleList();

    if (location.search) {
      handleSetFilterFromParams()
      let obj = {}; 
      for (const [key, value] of (new URLSearchParams(location.search)).entries()) {
        obj[key] = value; 
      }  
      getFiles(obj)
    } else {
      const filterQueryString = { search: '', idOperation: props.match.params.idOperation };

      getFiles(filterQueryString);
    }

  const region = authContext.region === 'en-GB' ? 'en' : 'en';


    cache.getTooltip("DOMAINS", region, "357", [594, 595, 596, 636], authContext.token).then(msg => {
      let obj = [];
      msg.map(element => {
        obj[element.MODEL_ITEM_ID] = element.MSG_TEXT;
      })
      setTooltips(obj)
    }).catch(err => console.log("error", err));
  }, []);

  //---------------------------
  //-- data of header
  //---------------------------
  function handleSummary() {
    useHeaderNbiRequest({idOperation: props.match.params.idOperation}, null).then(({data}) => {
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          currency: data.ret_value.currency,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
      })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  const getFiles = (filterQueryString = '', sortBy, callback) => {
    useGetDealDocumentsV2Request(null, filterQueryString).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          // history.goBack()
          return;
        }
        setDocuments(data.ret_value);
        setDealDocuments(data.ret_value?.dealDocuments?.length);
        setSignedDocuments(data.ret_value?.signedDocuments?.length);
        setInternalDocuments(data.ret_value?.internalDocuments?.length);
        setClaimsDocuments(data.ret_value?.claimsDocuments?.length);
        setSupportDocuments(data.ret_value?.supportDocuments?.length);
        setCommunicationDocuments(data.ret_value?.communicationDocuments?.length);
        setPaymentDocuments(data.ret_value?.paymentDocuments?.length);
        setNbiDocuments(data.ret_value?.nbiDocuments?.length)

        if (callback) callback();
      }).catch(err => {
        console.log(err);
      })
  }

  const handleSelectDocument = (documents) => {
    let updatedSelectedDocs = selectedDocs;

    documents.map(document => {
      const alreadySelected = selectedDocs.find((item) => item.idDocument === document.idDocument);

      if (!alreadySelected) {
        updatedSelectedDocs = ([...updatedSelectedDocs, document])
      } else {
        const docsFiltered = updatedSelectedDocs.filter((item) => item.idDocument !== document.idDocument);
        updatedSelectedDocs = docsFiltered;
      }
    });

    setSelectedDocs(updatedSelectedDocs)
  }


  const handleDownloadSelectedFiles = () => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);

    if (selectedDocs.length === 0 && !selectedAllDocsCheckBox) {
      mc.error("Please, select at least one document.")
      loading.stop();
      return;
    }

    const files = selectedDocs.map(file => ({
      lnkAccessPdf: file.url,
      idReport: file.idDocument,
      title: file.documentName
    }));

    let fileName = "";
    fitinsur.requestDownloadAllFiles(files, props.match.params.idOperation).then(response => {
      if (response.status !== 200) {
        loading.stop();
        throw new Error();
      }

      return response.blob().then((data) => {
        return {
          data: data,
          fileNameHeader: response.headers.get('Content-Disposition'),
        };
      });
    }).then(({ data, fileNameHeader }) => {
      const url = window.URL.createObjectURL(data);
      const a = document.createElement('a');

      fileName = fileNameHeader.split('filename=')[1].split('.')[0];

      a.style.display = 'none';
      a.href = url;
      a.download = fileName || 'extracted-files.zip';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      loading.stop();
    }).catch(err => {
      console.log('error', err)
      loading.stop();
    });
  }

  async function handleList() {
    useListMarketsRequest(null, {replaceQuestionAnswer: {}}).then(({data: res}) => {
        if (res.ret_code != 200) {
          //mc.error(res.ret_msg_details);
          //history.goBack();
          return;
        }
        let ids = [];
        res.ret_value.forEach((e) => {
          if ("existInsurer" in e) {
            if (e.existInsurer) {
              ids.push(e.ID_PERSON);
            }
          }
        })

        setInsurerInfo(res.ret_value.map(insurer => ({
          label: insurer.PERSON_FIRST_NAME,
          value: insurer.ID_PERSON,
        })));
    }).catch((error) => {
      mc.error(`There was an error while fetching your data: ${handleList.name}\n` + error);
      console.error('fitPostList - Error:', error);
    });
  }

  const showFilesExpired = (idDomain, idPerson, facilityName) => {
    console.log("facilityName", facilityName)
    useGetDealDocumentsRequest(null, {expired: true, idDomain: idDomain, idPerson: idPerson}).then(({data}) => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack()
          return;
        }
      setDialog(prev => ({ ...prev, visible: true, facilityName }))
      setTimeout(() => setDocumentsExpired(data.ret_value), 300)
      })
  }

  function handleSortList(key) {
    let direction = 'asc';
    if (sortBy.key === key && sortBy.direction === 'asc') {
      direction = 'desc';
    };
    const sort = { key: key, direction: direction }
    setSortBy(sort);
    getFiles(location.search, sort)

  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleBack() {
    history.goBack();
  };

  const fieldRenderOptions = function (options = []) {
    let result = []

    options.forEach(option => {

      let behavior = {}
      try {
        behavior = JSON.parse(option.ANSWER_BEHAVIOR)
      } catch (e) { }

      result.push({
        label: option.ANSWER_OPTION_DESCRIPTION,
        value: {
          idAnswerOption: option.ID_ANSWER_OPTION,
          dsAnswerOption: option.ANSWER_OPTION_DESCRIPTION,
          behavior,
        }
      });
    });
    return result;
  }

  function renderDocuments(title, nameArray, hasUpload, hasDelete, history = false, expired = false) {
    let documentsList = expired ? documentsExpired : documents;

    if (expired && (!documentsList[nameArray] || !documentsList[nameArray].length)) return <></>

    if (expired && dialog.facilityName) {
      documentsList[nameArray] = documentsList[nameArray].filter(d => d.facilityName === dialog.facilityName)
    }

    return (
      <>
        <>
        {title == "PREVIOUS VERSIONS" ? <div style={{ marginTop: "-30px", marginBottom: "30px"}}><Text>{title}</Text></div> : null}
          <Row style={{ marginBottom: '15px', width: '100%' }}>
            {columns ? columns.map((column, index) =>
              <Col sm={column.col} key={index} className={'d-none d-md-block pl-0 ' + column.style}>
                <Text onClick={() => handleSortList(column.value)}>
                  {column.title}
                </Text>
                {sortBy.key === column.value ? <>
                  {column.title == 'Action' ? null : sortBy.key === column.value && sortBy.direction === "asc" ?
                    <Icon name={"arrowup"} /> : <Icon name={"arrowdown"} />}</> : <></>}
              </Col>) : ""}

          </Row>
          {documentsList[nameArray] && documentsList[nameArray].map((document, index) => {
            return (
              <Row style={{ width: '100%', minWidth: '100%', justifyContent: 'space-between' }}>
                <React.Fragment key={index}>
                  <ListDetail
                    selectedFolder={renderScreen}
                    document={document}
                    idOperation={props.match.params.idOperation}
                    listDocuments={getFiles}
                    hasDelete={hasDelete}
                    columns={columns}
                    isClient={isClient}
                    nameArray={nameArray}
                    options={documentsList['documentTypesFiltered']}
                    handleSelectDocument={handleSelectDocument}
                    selectedDocs={selectedDocs}
                    selectAllDocs={selectedAllDocsCheckBox}
                    iconTooltips={tooltips}
                    onHistoryClick={history ? ({ idDomain, idPerson, facilityName }) => showFilesExpired(idDomain, idPerson, facilityName) : false}
                    history={history}
                    expired={expired}
                  />
                </React.Fragment>
                <br />
              </Row>
            )
          })}
        </>
      </>
    );
  }

  const jsonToQueryString = (json) => {
    const keys = Object.keys(json).filter(key => json[key]);

    return keys
      .map((key, index) => {
        const sufix = index + 1 === keys.length
          ? ''
          : '&'

        return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]) + sufix;
      }
      ).join('');
  }


  const handleSetFilterFromParams = () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);

      if (query.get('search')) {
        filterFormik.current?.setFieldValue('search', query.get('search'))
      }

      if (query.get('idOperation')) {
        filterFormik.current?.setFieldValue('idOperation', Number(query.get('idOperation')))
      }
    }
  }

  const handleFilter = (filters = {}) => {
    let filterQueryString;

    if (filters.search) {
      filterQueryString = { search: filters.search, idOperation: props.match.params.idOperation };
    } else {
      filterQueryString = { search: '', idOperation: props.match.params.idOperation };
    }

    getFiles(filterQueryString, sortBy);
    history.push(`?${jsonToQueryString(filterQueryString)}`)
  }

  const clearSearch = () => {
    formik.current?.setFieldValue('search', '')
  }

  let filterFormik = null;

  const checkNameArray = array => {
    const existsArray = nameArrayChecked.includes(array);

    if (!existsArray) {
      setNameArrayChecked([...nameArrayChecked, array]);
    } else {
      const filtered = nameArrayChecked.filter(named => named !== array);
      setNameArrayChecked(filtered);
    }
  }

  const renderAccordionDocuments = () => {
    return (
      <Container width={'100%'}>
        {signedDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['signedDocuments']); checkNameArray('signedDocuments') }} isChecked={nameArrayChecked.includes('signedDocuments')} hasCheckbox show={false} title={`SIGNED (${signedDocuments})`} collapsedAtStart="true">
            <Row show={false}>
              {renderDocuments('', 'signedDocuments', false, false, false, false)}
            </Row>
          </FormContainer>
        )}
        {paymentDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['paymentDocuments']); checkNameArray('paymentDocuments') }} isChecked={nameArrayChecked.includes('paymentDocuments')} hasCheckbox show={false} title={`PAYMENTS (${paymentDocuments})`} collapsedAtStart="true">
            <Row>
              {renderDocuments('', 'paymentDocuments', false, false, true, false)}
            </Row>
          </FormContainer>)}
        {dealDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['dealDocuments']); checkNameArray('dealDocuments') }} isChecked={nameArrayChecked.includes('dealDocuments')} hasCheckbox show={false} title={`POLICY DOCUMENTS (${dealDocuments})`} collapsedAtStart="true">
            <Row>
              {renderDocuments('', 'dealDocuments', false, false, true, false)}
            </Row>
          </FormContainer>)}
        {nbiDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['nbiDocuments']); checkNameArray('nbiDocuments') }} isChecked={nameArrayChecked.includes('nbiDocuments')} hasCheckbox show={false} title={`NBI DOCUMENTS (${nbiDocuments})`} collapsedAtStart="true" >
            <Row>
              {renderDocuments('', 'nbiDocuments', false, false, true, false)}
            </Row>
          </FormContainer>)}
        {supportDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['supportDocuments']); checkNameArray('supportDocuments') }} isChecked={nameArrayChecked.includes('supportDocuments')} hasCheckbox show={false} title={`UNDERWRITING DOCUMENTS (${supportDocuments})`} collapsedAtStart="true">
            <Row>
              {renderDocuments('', 'supportDocuments', false, false, false, false)}
            </Row>
          </FormContainer>)}
        {internalDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['internalDocuments']); checkNameArray('internalDocuments') }} isChecked={nameArrayChecked.includes('internalDocuments')} hasCheckbox show={false} title={`INTERNAL DOCUMENTS (${internalDocuments})`} collapsedAtStart="true">
            <Row>
              {!isClient ? renderDocuments('', 'internalDocuments', false, true, false, false) : null}
            </Row>
          </FormContainer>)}
        {communicationDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['communicationDocuments']); checkNameArray('communicationDocuments') }} isChecked={nameArrayChecked.includes('communicationDocuments')} hasCheckbox show={false} title={`COMUNICATIONS (${communicationDocuments})`} collapsedAtStart="true">
            <Row>
              {renderDocuments('', 'communicationDocuments', false, true, false, false)}
            </Row>
          </FormContainer>)}
        {claimsDocuments !== 0 && (
          <FormContainer onCheckChange={() => { handleSelectDocument(documents['claimsDocuments']); checkNameArray('claimsDocuments') }} isChecked={nameArrayChecked.includes('claimsDocuments')} hasCheckbox show={false} title={`CLAIMS (${claimsDocuments})`} collapsedAtStart="true" >
            <Row>
              {renderDocuments('', 'claimsDocuments', false, false, false, false)}
            </Row>
          </FormContainer>)}
      </Container>
    )
  }

  const changeShowAttachments = state => setShowAttachments(state);

  const changeAttachments = state => setAttachments(state);

  const changeVisiblity = state => setShowRateUs(state);

  const changeInsurerSelected = state => setInsurerSelected(state);

  const changeShowModalChat = state => setShowChatModal(state);

  return (
    <>
      <Layout title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"} subtitle={summary.dealCode ? summary.dealCode : "Deal Code"} idOperation={props.match?.params?.idOperation}>
        <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
        <BrokingSummary data={summary} />
        <Content>
          <ListHeader
            title="Documents"
            formikRef={ref => filterFormik = ref}
            ListHeader
            operationFilter={shouldRenderOperationFilter}
            changeShowAttachments={changeShowAttachments}
            showAttachmentsState={showAttachments}
            insurersList={insurerInfo}
            changeInsurerSelected={changeInsurerSelected}
            changeShowModalChat={changeShowModalChat}
            showChatModalState={showChatModal}
            updateFilter={(filters) => {
              handleFilter(filters)
            }}
            handleDownloadSelectedFiles={handleDownloadSelectedFiles}
            selectedAllDocsCheckBox={selectedAllDocsCheckBox}
            setSelectedAllDocsCheckBox={setSelectedAllDocsCheckBox}
            clearSearch={clearSearch}
            iconTooltips={tooltips}
          />
          <ListContent>

            {insurerSelected && showChatModal && (
              <MessageExchangeEmail
                isDocumentFolder
                show={showChatModal}
                idOperation={props.match?.params?.idOperation}
                idPersonInsurer={insurerSelected}
                referenceNumber={summary.dealCode}
              >
                <Text style={{ marginLeft: '20px', cursor: 'inherit', color: '#fff', fontSize: '18px' }}>{insurerInfo.find(insurer => insurer.value === insurerSelected).label}</Text>
                <Icon name="close" style={{ padding: '0 0.7rem', cursor: 'pointer', position: 'absolute', right: 0 }} onClick={() => setShowChatModal(false)} />
              </MessageExchangeEmail>)}


            {showAttachments && (
              <>
                <div style={{ marginBottom: '40px' }}>
                  <FolderSelect hasFolderSelect={renderScreen}>
                    <span style={{ color: Colors.GRAY[0] }} onClick={() => setRenderScreen('')}>ATTACHMENTS  &#40;{attachemnts.length}&#41;</span>
                  </FolderSelect>
                </div>

                <Formik
                  enableReinitialize={true}
                  initialValues={{}}
                  render={({ values, setFieldValue, validationSchema }) => (
                    <DragZoneUpload multiple={true}
                      options={fieldRenderOptions(documents['documentTypes'])}
                      changeShowAttachments={changeShowAttachments}
                      showAttachmentsState={showAttachments}
                      documentTypeRequired={true}
                      documentType={values.documentType}
                      idOperation={props.match.params.idOperation}
                      isDraft={false}
                      changeAttachments={changeAttachments}
                      onSuccess={() => {
                        const filterQueryString = { search: '', idOperation: props.match.params.idOperation };
                        getFiles(filterQueryString);
                      }}
                    />
                  )}
                />
              </>
            )}

            <Row style={{ justifyContent: 'flex-end', margin: '10px' }}>
              <Col md={4}>
                <Formik
                  onSubmit={(values) => {
                    handleFilter(values)
                  }}
                  initialValues={initialValues}
                  innerRef={formik}
                  enableReinitialization={true}
                >
                  {(formikProps) => {
                    return (
                      <Form>
                        <RowSearch>
                          <FieldGrid
                            name="search"
                            placeholder="Search"
                            value={formikProps.values.search}
                            component={InputField}
                            type="text"
                            onChange={(e) => {
                              formikProps?.setFieldValue('search', e)
                            }}
                            validation={false}
                            list={true}
                            onPressEnter={() => {
                              formikProps.submitForm()
                            }}
                          />
                        </RowSearch>
                      </Form>
                    )
                  }}
                </Formik>
              </Col>
            </Row>

            {renderAccordionDocuments()}
            <DialogComponent title={dialog.title} size='1000px' show={dialog.visible} setDialog={setDialog} center>
              <div style={{ margin: 30 }}>
              {renderDocuments('PREVIOUS VERSIONS', 'dealDocuments', false, false, false, true)}
              {renderDocuments('PREVIOUS VERSIONS', 'paymentDocuments', false, false, false, true)}
              {renderDocuments('PREVIOUS VERSIONS', 'nbiDocuments', false, false, false, true)}
                <ButtonContainer className='justify-content-end'>
                <ButtonContent>
                  <Button
                    id="btnContinue"
                    type="button"
                    style={{ margin: '0 0 15px 15px' }}
                    onClick={() => setDialog(prev => ({ ...prev, visible: false }))}
                    third
                  >
                    CLOSE
                  </Button>
                </ButtonContent>
              </ButtonContainer>
            </div>
          </DialogComponent>

            <ButtonContainer>
              <Button forth onClick={() => handleBack()}>&lt; Back</Button>
            </ButtonContainer>
            {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
          </ListContent>
        </Content>
      </Layout>
    </>
  )
}
